import COUNTRY_LIST from "../../utils/countryList";

const ViewVeeva = ({ data }) => {
    const { country, title, veevaId } = data;

    return (
        <>
            <h5 className="tab-pane__title">Veeva Information</h5>
            <div className="row info-table">
                <div className="col-lg-12">
                    <div className="row info-table__tr mb-2">
                        <div className="col-6">
                            <div className="row">
                                <div className="col-4">Veeva ID</div>
                                <div className="col-8">
                                    <div className="table_value_pre">
                                        <strong>{veevaId}</strong>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="col-6">
                            <div className="row">
                                <div className="col-4">Title</div>
                                <div className="col-8">
                                    <div className="table_value_pre">
                                        <strong>{title}</strong>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="row info-table__tr mb-2">
                        <div className="col-6">
                            <div className="row">
                                <div className="col-4">Country</div>
                                <div className="col-8">
                                    <div className="table_value_pre">
                                        <strong>
                                            {country && COUNTRY_LIST[country.toUpperCase()]}
                                        </strong>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
};

export default ViewVeeva;
